// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction8_wrapper__Lx9qz","button":"introduction8_button__I4jdq"};